import { useEffect, useState } from 'react';
import THANK_YOU from '../../assets/icons/ComniqaiIcon-V2.0/complated-icon.svg';
import { getLocalStorage, getWithToken } from '../../API/Api';
import Loader from '../../components/Loader';
import { FiDownload } from 'react-icons/fi';
import COMNIQ_LOGO from '../../assets/images/comniqAI/comniq-logo-dark.svg';

const SubThankyou = () => {
  const [subscriptionDetails, setSubscriptionDetails] = useState('');
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setLoader(true);
      setTimeout(() => {
        getSubscriptionDetails(JSON.parse(token));
      }, 3000);
    }
  }, []);

  const getSubscriptionDetails = async (token) => {
    setLoader(true);
    try {
      const response = await getWithToken('get_subscription', token);
      if (response?.subscription) {
        setSubscriptionDetails(response?.subscription);
      }
    } catch (error) {
      console.error('Error while fetching subscription details:', error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div className='invoice-wrapper my-5'>
        <div className='invoice-card shadow-lg'>
          {/* HEADER */}
          <div className='invoice-header p-4'>
            <div className='logo-box d-flex align-items-center'>
              <img src={COMNIQ_LOGO} alt='ComniqAI Logo' width={160} />
            </div>
            <div className='d-flex align-items-center justify-content-end'>
              <button
                className='btn-generatedlead outfit-medium d-flex align-items-center gap-2'
                disabled={!subscriptionDetails?.invoice_pdf_url}
                onClick={() => window.open(subscriptionDetails?.invoice_pdf_url, '_blank')}
              >
                <FiDownload size={18} />
                Download Invoice
              </button>
            </div>
          </div>

          {/* BODY */}
          <div className='card-body px-4 py-5'>
            <div className='row mb-4'>
              <div className='col-md-6'>
                <p className='label-text outfit-medium mb-2'>Invoice to:</p>
                <h6 className='outfit-bold mb-0'>{subscriptionDetails?.user_name || ''}</h6>
                <p className='mb-0 small'>{subscriptionDetails?.user_email || ''}</p>
                <p className='mb-0 small'>{subscriptionDetails?.country_name || '-'}</p>
              </div>
              <div className='col-md-3'>
                <p className='label-text outfit-medium mb-2'>Date:</p>
                <h6 className='outfit-bold'>{subscriptionDetails?.invoice_date || '-'}</h6>
              </div>
              <div className='col-md-3'>
                <p className='label-text outfit-medium mb-2'>Invoice number:</p>
                <h6 className='outfit-bold'>{subscriptionDetails?.invoice_number || ''}</h6>
              </div>
            </div>

            {/* ORDER TABLE */}
            <div className='table-responsive my-5'>
              <table className='invoice-table table align-middle'>
                <thead className=''>
                  <tr>
                    <th>Item</th>
                    <th className='text-end'>Price</th>
                    <th className='text-center'>Billing Cycle</th>
                    <th className='text-center'>Qty</th>
                    <th className='text-end'>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{subscriptionDetails?.plan || ''}</td>
                    <td className='text-end'>${subscriptionDetails?.price || 0}</td>
                    <td className='text-center'>{subscriptionDetails?.billing_cycle || 'month'}</td>
                    <td className='text-center'>1</td>
                    <td className='text-end'>${subscriptionDetails?.price || 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* TOTALS */}
            <div className='row'>
              <div className='col-md-6'>
                <p className='small text-muted outfit-regular'>
                  <strong>Terms & Conditions:</strong>
                  <br />
                  Fees and payment terms will be established in the contract or agreement prior to commencement of the project. An initial deposit will be required before any work
                  begins. We reserve the right to suspend or halt in case of non-payment.
                </p>
              </div>
              <div className='col-md-6'>
                <ul className='list-unstyled text-end'>
                  <li className='outfit-regular'>
                    <strong>Subtotal:</strong> ${subscriptionDetails?.price || 0}
                  </li>
                  {/* <li className='outfit-regular text-muted'>
                    <strong>Discount (Special Offer):</strong> $0
                  </li>
                  <li className='outfit-regular'>
                    <strong>Tax:</strong> ${subscriptionDetails?.tax || 0}
                  </li> */}
                  <li className='outfit-regular fs-6 mt-2'>
                    <strong className='outfit-bold'>Invoice Total:</strong> ${subscriptionDetails?.price || 0}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div className='invoice-footer d-flex justify-content-center align-items-center px-4 py-3'>
            <div className='outfit-regular small text-muted'>
              © {new Date().getFullYear()} ComniqAI |{' '}
              <a href='https://www.comniqai.com' target='_blank' rel='noopener noreferrer' className='outfit-regular text-decoration-none text-muted'>
                www.comniqai.com
              </a>{' '}
              |{' '}
              <a href='mailto:contact@comniqai.com' className='outfit-regular text-decoration-none text-muted'>
                contact@comniqai.com
              </a>
            </div>
            {/* <div className='d-flex align-items-center'>
              <div className='logo-box'>
                <img src={COMNIQ_LOGO} alt='ComniqAI Logo' width={160} />
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {loader && (
        <div className='loader-center'>
          <Loader />
        </div>
      )}
    </>
  );
};

export default SubThankyou;
